import React from 'react';
import { Box, Typography, Button, SvgIcon } from '@mui/material';

export interface EmptyStateProps {
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonVariant?: 'text' | 'outlined' | 'contained';
  buttonSx?: Record<string, any>;
  showButton?: boolean;
  icon?: React.ReactNode;
  minHeight?: string | number;
  maxWidth?: string | number;
  sx?: Record<string, any>;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
  buttonVariant = 'text',
  buttonSx = {},
  showButton = true,
  icon,
  maxWidth = '500px',
  sx = {},
}) => {
  const defaultIcon = (
    <SvgIcon
      sx={{
        color: 'text.disabled',
        fontSize: '2rem',
      }}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
        fill="none"
        stroke="currentColor"
      />
    </SvgIcon>
  );

  return (
    <Box sx={{ position: 'relative', width: '100%', ...sx }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          // textAlign: 'center',
          maxWidth,
          mx: 'auto',
          marginTop: '0rem',
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            backgroundColor: 'action.hover',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          {icon || defaultIcon}
        </Box>

        <Typography
          variant="h6"
          sx={{
            color: 'text.primary',
            fontWeight: 600,
            mb: 2,
            fontSize: '1.25rem',
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          {description}
        </Typography>

        {showButton && buttonText && onButtonClick ? (
          <>
            <Box
              sx={{
                width: 8,
                height: 8,
              }}
            />
            <Button
              variant={buttonVariant}
              sx={{
                color: 'primary.main',
                fontWeight: 500,
                ...buttonSx,
              }}
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default EmptyState;
